// OS (Orden de Servicio): la asigna un proveedor externo o, si se elige al crear la orden, es la OT interna.
// Texto de 1 a 14 caracteres A–Z y 0–9, guardado en mayúsculas. Si es solo numérico se quitan los
// ceros a la izquierda ("00123" = "123") y un valor solo de ceros se rechaza. Replica
// private.normalize_folio; el servidor es la autoridad.

export const FOLIO_MAX_LENGTH = 14;

export type FolioResult = { ok: true; value: string } | { ok: false; error: string };

export function parseFolio(input: string): FolioResult {
  let text = input.trim().toUpperCase();
  if (text === '') return { ok: false, error: 'Ingresa la OS.' };
  if (!/^[A-Z0-9]+$/.test(text))
    return { ok: false, error: 'La OS solo admite letras A–Z y números, sin espacios ni signos.' };
  if (/^\d+$/.test(text)) {
    if (/^0+$/.test(text)) return { ok: false, error: 'La OS no puede ser solo ceros.' };
    text = text.replace(/^0+/, '');
  }
  if (text.length > FOLIO_MAX_LENGTH)
    return { ok: false, error: `La OS admite máximo ${FOLIO_MAX_LENGTH} caracteres.` };
  return { ok: true, value: text };
}
